module.exports = __webpack_public_path__ + "img/IQ.56749ff5.png";